var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinterFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12v10a1 1 0 01-1 1h-4v4a1 1 0 01-1 1H8a1 1 0 01-1-1v-4H3a1 1 0 01-1-1V12c0-1.654 1.42-3 3.166-3H7V5a1 1 0 011-1h16a1 1 0 011 1v4h1.834C28.58 9 30 10.346 30 12zM9 9h14V6H9v3zm14 11H9v6h14v-6zm2-5.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
  })));
}
export default SvgPrinterFill;